var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { indentBlocks, isIndented, canIndentAsListItem, hasNode, sinkListItem } from '@progress/kendo-editor-common';
import { onDownPreventDefault } from './utils';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { messages } from './../messages';
/**
 * @hidden
 */
export var IndentToolNS;
(function (IndentToolNS) {
    /**
     * @hidden
     */
    IndentToolNS.createIndentTool = function (settings) {
        var Tool = /** @class */ (function (_super) {
            __extends(IndentTool, _super);
            function IndentTool() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            IndentTool.prototype.render = function () {
                var _a = this.props, view = _a.view, render = _a.render, buttonProps = __rest(_a, ["view", "render"]);
                var state = view && view.state;
                var nodes = state && state.schema.nodes;
                var listItem = nodes && nodes[settings.listsTypes.listItem];
                var actions = settings.actions;
                var canIndented = !!state &&
                    (isIndented(state, actions, buttonProps.dir) ||
                        actions.some(function (a) { return nodes[a.node] && hasNode(state, nodes[a.node]); })) &&
                    !hasNode(state, listItem);
                var canListIndent = !!state && canIndentAsListItem(state, listItem);
                var canIndent = canIndented || canListIndent;
                var localization = provideLocalizationService(this);
                var titleKey = settings.messages.title;
                var button = (React.createElement(Button, __assign({ onClick: function () {
                        if (view && canListIndent) {
                            sinkListItem(listItem)(view.state, view.dispatch);
                        }
                        else if (view && canIndented) {
                            indentBlocks(actions, settings.commandName, buttonProps.dir)(view.state, view.dispatch);
                        }
                    }, title: localization.toLanguageString(titleKey, messages[titleKey]), disabled: !canIndent }, onDownPreventDefault, settings.props, buttonProps)));
                return render ? render.call(undefined, button, { view: view }) : button;
            };
            return IndentTool;
        }(React.Component));
        registerForLocalization(Tool);
        return Tool;
    };
})(IndentToolNS || (IndentToolNS = {}));
//# sourceMappingURL=indent.js.map